import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClientEmployeeDynamicFormRoutingModule } from './client-employee-dynamicform-routing.module';
import { ClientEmployeeDynamicFormComponent } from './client-employee-dynamicform.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ClientEmployeeDynamicformListComponent } from './client-employee-dynamicform-list/client-employee-dynamicform-list.component';
import { ClientEmployeeDynamicformEditComponent } from './client-employee-dynamicform-edit/client-employee-dynamicform-edit.component';

@NgModule({
    declarations: [
        ClientEmployeeDynamicFormComponent,
        ClientEmployeeDynamicformListComponent,
        ClientEmployeeDynamicformEditComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule, 
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        ClientEmployeeDynamicFormRoutingModule,
        PdfViewerModule,
        NgxExtendedPdfViewerModule
    ],
    exports: [ClientEmployeeDynamicFormComponent,
        ClientEmployeeDynamicformListComponent,
        ClientEmployeeDynamicformEditComponent],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService],
})
export class ClientEmployeeDynamicFormModule { }
